/*!
 * Manera Home
 * 
 */
$(document).ready(function(){

});


